export default __webpack_public_path__ + "static/cert-6-d7430e519af6414be7601e5f3ed80830.png";